import React from 'react'

export default () => {
	return (
		<svg className='icon-deposit' viewBox='158.164 121.918 183.697 182.477' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M 178.707 122.42 L 321.293 122.42 C 332.339 122.42 341.293 131.374 341.293 142.42 L 341.293 198.726 C 341.293 209.772 332.339 218.726 321.293 218.726 L 303.598 218.726 L 303.598 187.229 C 303.598 176.183 294.644 167.229 283.598 167.229 L 216.402 167.229 C 205.356 167.229 196.402 176.183 196.402 187.229 L 196.402 218.726 L 178.707 218.726 C 167.661 218.726 158.707 209.772 158.707 198.726 L 158.707 142.42 C 158.707 131.374 167.661 122.42 178.707 122.42 Z'
				style={{ stroke: 'currentColor', fill: 'currentColor' }}
			/>
			<path
				d='M 207.878 283.746 L 207.878 196.758 C 207.878 185.712 216.832 176.758 227.878 176.758 L 272.148 176.758 C 283.194 176.758 292.148 185.712 292.148 196.758 L 292.148 283.746 C 292.148 294.792 283.194 303.746 272.148 303.746 L 227.878 303.746 C 216.832 303.746 207.878 294.792 207.878 283.746 Z M 256.759 288.487 L 256.759 241.611 L 271.759 241.611 L 251.759 193.685 L 231.759 241.611 L 246.759 241.611 L 246.759 288.487 Z'
				style={{ stroke: 'currentColor', fill: 'currentColor' }}
			/>
		</svg>
	)
}
